import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { Box, Typography } from '@mui/material';
import { blueTextStyle, unorderedListStyle } from './styles';
var _a = appStrings.modules.nugget.scholarship, ELIGIBILITY_REQUIREMENTS_STRINGS = _a.ELIGIBILITY_REQUIREMENTS_STRINGS, SECTION_TITLES = _a.SECTION_TITLES;
function generateAgeRangeString(min, max) {
    if (min && max) {
        return "".concat(min, " - ").concat(max);
    }
    if (min) {
        return "".concat(min, "+");
    }
    if (max) {
        return "".concat(max, "-");
    }
    return undefined;
}
export function EligibilityRequirements(_a) {
    var _b;
    var scholarshipInfo = _a.scholarshipInfo;
    var levelOfStudyArray = (_b = scholarshipInfo.eligibility_level_of_study) === null || _b === void 0 ? void 0 : _b.split(',');
    var levelOfStudyString = levelOfStudyArray
        ? levelOfStudyArray.length > 2
            ? "".concat(levelOfStudyArray[0], " - ").concat(levelOfStudyArray[levelOfStudyArray.length - 1])
            : scholarshipInfo.eligibility_level_of_study
        : '';
    var eligibilityData = [
        {
            title: '',
            value: scholarshipInfo.eligibility_time_status,
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.LEVEL_OF_STUDY_FRONT,
            value: levelOfStudyString,
            suffix: ELIGIBILITY_REQUIREMENTS_STRINGS.LEVEL_OF_STUDY_END,
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.INSTITUTION_TYPE,
            value: scholarshipInfo.eligibility_institution_type,
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.LIMITED_HS,
            value: scholarshipInfo.eligibility_applicant_type_limited_hs === true ? '' : null,
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.CITIZENSHIP,
            value: scholarshipInfo.eligibility_citizenship,
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.AGE,
            value: generateAgeRangeString(scholarshipInfo.eligibility_age_min, scholarshipInfo.eligibility_age_max),
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.GENDER,
            value: scholarshipInfo.eligibility_gender,
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.RACE_ETHNICITY,
            value: scholarshipInfo.eligibility_race_ethnicity,
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.DISABILITY_TYPE,
            value: scholarshipInfo.eligibility_disability_type,
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.MILITARY_SERVICE,
            value: scholarshipInfo.eligibility_military_type,
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.STATE_RESIDENCE,
            value: scholarshipInfo.prog_restrict_state_residence,
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.COUNTY_RESIDENCE,
            value: scholarshipInfo.prog_restrict_county_residence,
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.INSTITUTION,
            value: scholarshipInfo.prog_restrict_institution,
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.AREA_OF_STUDY,
            value: scholarshipInfo.prog_restrict_area_study,
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.HERITAGE,
            value: scholarshipInfo.prog_restrict_ethnicity_heritage,
        },
        {
            title: ELIGIBILITY_REQUIREMENTS_STRINGS.RELIGIOUS_AFFILIATION,
            value: scholarshipInfo.prog_restrict_religious_affiliation,
        },
    ];
    var eligibilityItems = eligibilityData
        .filter(function (item) { return item.value !== null && item.value !== undefined && item.value !== ''; })
        .map(function (item, index) { return (_jsxs("li", { children: [item.title, " ", item.value, " ", item.suffix ? item.suffix : ''] }, index)); });
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "body1", sx: blueTextStyle, children: SECTION_TITLES.eligibilityRequirements }), _jsx("ul", { style: unorderedListStyle, children: eligibilityItems })] }));
}
